export const content = {
  fr: {
    nav: {
      fiction: "Fiction",
      facilitator: "Évènementiel",
      photo: "Photographie",
      contact: "Contact",
      tagline: "Organisation évènementielle · Producteur",
    },
    hero: {
      overline: "Paris — International",
      line1: "Organisation",
      line2: "évènementielle,",
      line3: "producteur de fiction.",
      sub: "Producteur de fiction, producteur exécutif, créateur d'événements : je suis multicasquettes — et c'est précisément ma force. Une seule constante : trouver des solutions à tout, optimiser chaque euro, et mener chaque projet jusqu'au bout.",
      cta1: "Discuter d'un projet",
      cta2: "Voir la filmographie",
      badge1: "Organisation évènementielle",
      badge2: "Producteur cinéma & TV",
      badge3: "Producteur exécutif — France",
      scroll: "Défiler",
      imgAlt: "Caméra cinéma sur un plateau de tournage",
    },
    ticker:
      "Des solutions à tout — Producteur de fiction — Optimisation budgétaire — Producteur exécutif, tournages étrangers en France — Gestion de crise — Paris & International — ",
    stats: {
      title: "Ils m'ont fait confiance",
      items: [
        { value: 18, suffix: "", label: "ans d'expérience" },
        { value: 20, suffix: "+", label: "tournées supervisées" },
        { value: 9, suffix: "", label: "films & séries produits" },
        { value: 1, suffix: "", label: "cérémonie olympique" },
      ],
      brands: [
        { name: "Paris 2024", domain: "olympics.com" },
        { name: "Roland-Garros", domain: "rolandgarros.com" },
        { name: "The Evian Championship", domain: "evianchampionship.com" },
        { name: "Nestlé", domain: "nestle.com" },
        { name: "Amundi", domain: "amundi.com" },
        { name: "HighCo", domain: "highco.com" },
      ],
    },
    fiction: {
      overline: "Chapitre 02",
      title: "Producteur de fiction",
      body: "Je développe et produis des films et des séries, du premier regard sur un scénario jusqu'à la salle obscure. J'aime les histoires qui prennent des risques — et les équipes qui les portent jusqu'au bout. Fort d'un excellent relationnel avec les artistes — acteurs, réalisateurs, auteurs — je sais réunir les bonnes personnes autour d'un projet.",
      featuredTag: "En production — 2026",
      featuredTitle: "QUANTIC",
      featuredBody:
        "Premier long-métrage réalisé par David Sarrio, actuellement en production.",
      featuredLink: "Lire l'annonce",
      openYoutube: "Ouvrir sur YouTube",
      teaserTitle: "Mon travail en images",
      teaserBody: "Une minute de productions, entre plateaux et events",
      watch: "Voir",
      othersTitle: "Directeur de casting — sélection de projets",
      types: { film: "Long-métrage", series: "Série", short: "Court-métrage" },
    },
    exec: {
      overline: "Chapitre 03",
      title: "Producteur exécutif en France",
      body: "Sociétés de production étrangères : vous voulez tourner à Paris ou ailleurs en France ? Je porte votre tournage de bout en bout — je trouve les solutions, j'optimise le budget, je monte les équipes.",
      cta: "Discuter de votre tournage",
      imgAlt: "Rue parisienne — accueillir les tournages étrangers en France",
      points: [
        {
          id: "solutions",
          title: "Des solutions à tout",
          text: "Un imprévu ? C'est là que je suis le meilleur. Chaque problème de tournage a une solution — mon travail est de la trouver, vite.",
        },
        {
          id: "budget",
          title: "Budgets optimisés",
          text: "Chaque euro compte. Je négocie, mutualise et arbitre pour que votre argent aille à l'écran, pas dans les frictions.",
        },
        {
          id: "talents",
          title: "Équipes & talents locaux",
          text: "Grâce à mon relationnel avec les artistes et les techniciens — acteurs, réalisateurs, auteurs — je réunis vite les bonnes personnes.",
        },
        {
          id: "scouting",
          title: "Repérages & autorisations",
          text: "Lieux, permis de tournage, logistique : je connais les rouages administratifs français et les interlocuteurs qui comptent.",
        },
      ],
    },
    facilitator: {
      overline: "Chapitre 01",
      title: "Organisation évènementielle",
      body: "Près de vingt ans d'événementiel au plus haut niveau : cérémonies olympiques, tournois du Grand Chelem, et plus de 20 tournées supervisées pour des marques — de Nestlé aux lancements automobiles. Gestion du temps, gestion des ressources, problèmes réglés à la dernière minute : mon métier, c'est d'identifier les problèmes avant qu'ils n'arrivent, de trouver des solutions quand ils arrivent — et d'optimiser chaque euro.",
      role: "Rôle",
      tabs: [
        {
          id: "crise",
          label: "Gestion de crise",
          text: "Cérémonie d'ouverture des Jeux Olympiques, événements mondiaux retransmis en direct : je suis formé à décider vite, hiérarchiser l'essentiel et garder le cap quand tout s'accélère.",
        },
        {
          id: "stress",
          label: "Gestion du stress",
          text: "Des équipes entières comptent sur une voix calme. Je mets ma capacité à rester lucide sous pression au service de la vôtre — pour que vos équipes travaillent sereinement, même dans l'urgence.",
        },
        {
          id: "diagnostic",
          label: "Identification des problèmes",
          text: "Logistique, flux, coordination : je repère les points de fragilité d'une organisation avant qu'ils ne deviennent des incidents. Un bon événement se prépare bien avant le jour J.",
        },
        {
          id: "solutions",
          label: "Solutions de dernière minute",
          text: "Pas de théorie : des plans concrets, des responsabilités claires, des outils simples. Et quand un problème surgit à la dernière minute — ça arrive toujours — je le règle avant que quiconque ne s'en aperçoive.",
        },
        {
          id: "temps",
          label: "Temps & ressources",
          text: "Un planning est une promesse. J'orchestre les rotations d'équipes, les flux de matériel et les ressources humaines pour que chaque minute et chaque euro soient utiles.",
        },
        {
          id: "budget",
          label: "Optimisation budgétaire",
          text: "Un bon événement n'est pas le plus cher, c'est le mieux arbitré. Je sais où l'argent fait la différence — et où l'économiser sans que personne ne s'en aperçoive.",
        },
        {
          id: "creation",
          label: "Création d'événements",
          text: "De l'idée au jour J : je conçois des événements sur mesure — ou je supervise les vôtres. Concept, parcours invités, coordination générale : vous gardez la vision, je porte la réalité du terrain.",
        },
      ],
      events: [
        {
          id: "jo-paris-2024",
          title: "JO Paris 2024",
          role: "Responsable Logistique Nuit — Cérémonie d'ouverture",
          desc: "Pilotage de l'intégralité des opérations logistiques nocturnes : installation des infrastructures, coordination des équipes et sécurisation du bon déroulé d'une cérémonie historique, suivie dans le monde entier.",
          period: "2024",
          link: "https://www.youtube.com/watch?v=eCXY9_6fCe0",
        },
        {
          id: "roland-garros",
          title: "Roland-Garros",
          role: "Responsable Logistique Transport — Joueurs, têtes de série & VIP",
          desc: "Organisation et supervision de l'ensemble des déplacements des joueurs, têtes de série et VIP : ponctualité absolue, discrétion et niveau d'exigence d'un tournoi du Grand Chelem.",
          period: "2014",
          link: "https://www.rolandgarros.com/fr-fr",
        },
        {
          id: "evian-championship",
          title: "The Evian Championship",
          role: "Responsable Logistique Transport — Joueurs, têtes de série & VIP",
          desc: "Direction de la logistique transport sur quatre éditions consécutives : planification des flux, gestion des imprévus et accueil sur mesure des plus grandes joueuses du circuit mondial.",
          period: "2010 — 2013",
          link: "https://amundi.evianchampionship.com/",
        },
        {
          id: "brand-tours",
          title: "Tournées événementielles",
          role: "Régisseur Général — +20 tournées de lancement",
          desc: "Supervision de plus de vingt tournées événementielles pour des marques nationales et internationales — de Nestlé aux lancements automobiles : budgets, équipes, itinéraires et exécution sans faille.",
          period: "2006 — 2014",
          link: "https://www.highco.com/",
        },
      ],
      imgAlt: "Cérémonie d'ouverture des Jeux Olympiques Paris 2024 au Trocadéro",
    },
    photo: {
      overline: "Chapitre 03",
      title: "Photographe",
      body: "Une activité annexe, un regard à part entière. Portraits, lumière, matière : la photographie est ma manière de ralentir — et de voir.",
      filters: { all: "Tout", portrait: "Portraits", fineart: "Fine art" },
      close: "Fermer",
    },
    links: {
      overline: "Ailleurs",
      title: "Retrouvez-moi",
      items: [
        { id: "linktree", label: "Linktree", desc: "Tous mes liens", url: "https://linktr.ee/thomaslubeau" },
        { id: "instagram", label: "Instagram", desc: "@thomaslubeau", url: "https://instagram.com/thomaslubeau" },
        { id: "linkedin", label: "LinkedIn", desc: "Thomas Lubeau", url: "https://www.linkedin.com/in/thomas-lubeau-2b1b64a5" },
        { id: "facebook", label: "Facebook", desc: "Thomas Lubeau", url: "https://www.facebook.com/thomas.lubeau" },
      ],
    },
    contact: {
      overline: "Contact",
      title: "Parlons de votre projet",
      body: "Société de production, agence événementielle ou entreprise : écrivez-moi, je réponds vite.",
      name: "Votre nom",
      namePh: "Prénom Nom",
      email: "Votre email",
      emailPh: "vous@societe.com",
      type: "Type de projet",
      types: {
        production: "Production de fiction",
        executive: "Production exécutive — tournage en France",
        event: "Organisation évènementielle",
        other: "Autre",
      },
      message: "Votre message",
      messagePh: "Quelques mots sur votre projet, vos dates, vos besoins…",
      submit: "Envoyer le message",
      sending: "Envoi…",
      success: "Message envoyé — merci, je vous réponds très vite.",
      error: "Une erreur est survenue. Réessayez ou écrivez-moi directement par email.",
      directEmail: "Email direct",
      copy: "Copier",
      copied: "Adresse copiée",
    },
    footer: "© 2026 Thomas Lubeau — lubeau.com",
  },
  en: {
    nav: {
      fiction: "Fiction",
      facilitator: "Events",
      photo: "Photography",
      contact: "Contact",
      tagline: "Event management · Producer",
    },
    hero: {
      overline: "Paris — Worldwide",
      line1: "Event",
      line2: "management,",
      line3: "fiction producer.",
      sub: "Fiction producer, executive producer, event creator: I wear many hats — and that is precisely my strength. One constant: finding solutions to everything, making every euro count, and carrying every project through.",
      cta1: "Discuss a project",
      cta2: "View filmography",
      badge1: "Event management",
      badge2: "Film & TV producer",
      badge3: "Executive producer — France",
      scroll: "Scroll",
      imgAlt: "Cinema camera on a film set",
    },
    ticker:
      "Solutions to everything — Fiction producer — Budget optimization — Executive producer for foreign shoots in France — Crisis management — Paris & Worldwide — ",
    stats: {
      title: "Trusted by",
      items: [
        { value: 18, suffix: "", label: "years of experience" },
        { value: 20, suffix: "+", label: "tours supervised" },
        { value: 9, suffix: "", label: "films & series produced" },
        { value: 1, suffix: "", label: "Olympic ceremony" },
      ],
      brands: [
        { name: "Paris 2024", domain: "olympics.com" },
        { name: "Roland-Garros", domain: "rolandgarros.com" },
        { name: "The Evian Championship", domain: "evianchampionship.com" },
        { name: "Nestlé", domain: "nestle.com" },
        { name: "Amundi", domain: "amundi.com" },
        { name: "HighCo", domain: "highco.com" },
      ],
    },
    fiction: {
      overline: "Chapter 02",
      title: "Fiction producer",
      body: "I develop and produce films and series — from the first read of a script to the dark of the theatre. I love stories that take risks, and the crews that carry them through. With a strong, trusted relationship with talent — actors, directors, writers — I know how to bring the right people together around a project.",
      featuredTag: "In production — 2026",
      featuredTitle: "QUANTIC",
      featuredBody: "First feature film directed by David Sarrio, currently in production.",
      featuredLink: "Read the announcement",
      openYoutube: "Open on YouTube",
      teaserTitle: "My work in images",
      teaserBody: "One minute of production, between sets and events.",
      watch: "Watch",
      othersTitle: "Casting director — selected projects",
      types: { film: "Feature film", series: "Series", short: "Short film" },
    },
    exec: {
      overline: "Chapter 03",
      title: "Executive producer in France",
      body: "Foreign production companies: want to shoot in Paris or anywhere in France? I carry your shoot from start to finish — I find the solutions, I optimize the budget, I build the crews.",
      cta: "Discuss your shoot",
      imgAlt: "Parisian street — welcoming foreign shoots in France",
      points: [
        {
          id: "solutions",
          title: "Solutions to everything",
          text: "An unexpected problem? That's where I'm at my best. Every shoot problem has a solution — my job is finding it, fast.",
        },
        {
          id: "budget",
          title: "Optimized budgets",
          text: "Every euro counts. I negotiate, pool and arbitrate so your money ends up on screen, not lost in friction.",
        },
        {
          id: "talents",
          title: "Local crews & talent",
          text: "Thanks to my trusted relationships with artists and technicians — actors, directors, writers — I assemble the right people fast.",
        },
        {
          id: "scouting",
          title: "Scouting & permits",
          text: "Locations, shooting permits, logistics: I know the ins and outs of French administration and the people who matter.",
        },
      ],
    },
    facilitator: {
      overline: "Chapter 01",
      title: "Event management",
      body: "Nearly twenty years of top-tier events: Olympic ceremonies, Grand Slam tournaments, and 20+ supervised tours for brands — from Nestlé to car launches. Time management, resource management, last-minute fixes: my job is spotting problems before they happen, finding solutions when they do — and making every euro count.",
      role: "Role",
      tabs: [
        {
          id: "crise",
          label: "Crisis management",
          text: "Olympic opening ceremonies, live-broadcast global events: I am trained to decide fast, prioritize what matters and stay on course when everything accelerates.",
        },
        {
          id: "stress",
          label: "Stress management",
          text: "Entire teams rely on a calm voice. I put my ability to stay clear-headed under pressure at the service of yours — so your teams can work serenely, even in emergencies.",
        },
        {
          id: "diagnostic",
          label: "Problem identification",
          text: "Logistics, flows, coordination: I spot the weak points of an organisation before they become incidents. A great event is prepared long before day one.",
        },
        {
          id: "solutions",
          label: "Last-minute solutions",
          text: "No theory: concrete plans, clear responsibilities, simple tools. And when a problem pops up at the last minute — it always does — I fix it before anyone even notices.",
        },
        {
          id: "temps",
          label: "Time & resources",
          text: "A schedule is a promise. I orchestrate crew rotations, material flows and human resources so that every minute and every euro is useful.",
        },
        {
          id: "budget",
          label: "Budget optimization",
          text: "A great event isn't the most expensive one — it's the best-arbitrated one. I know where money makes a difference, and where to save it without anyone noticing.",
        },
        {
          id: "creation",
          label: "Event creation",
          text: "From the idea to day one: I design tailor-made events — or I supervise yours. Concept, guest journey, overall coordination: you keep the vision, I carry the reality on the ground.",
        },
      ],
      events: [
        {
          id: "jo-paris-2024",
          title: "Paris 2024 Olympic Games",
          role: "Head of Night Logistics — Opening Ceremony",
          desc: "Ran all night-time logistics operations: infrastructure installation, crew coordination and the smooth running of a historic ceremony watched around the world.",
          period: "2024",
          link: "https://www.youtube.com/watch?v=eCXY9_6fCe0",
        },
        {
          id: "roland-garros",
          title: "Roland-Garros",
          role: "Head of Transport Logistics — Players, top seeds & VIPs",
          desc: "Organised and supervised every movement of players, top seeds and VIPs: absolute punctuality, discretion and the exacting standards of a Grand Slam tournament.",
          period: "2014",
          link: "https://www.rolandgarros.com/fr-fr",
        },
        {
          id: "evian-championship",
          title: "The Evian Championship",
          role: "Head of Transport Logistics — Players, top seeds & VIPs",
          desc: "Led transport logistics across four consecutive editions: flow planning, last-minute problem solving and a tailored welcome for the greatest players on the world tour.",
          period: "2010 — 2013",
          link: "https://amundi.evianchampionship.com/",
        },
        {
          id: "brand-tours",
          title: "Event tours",
          role: "General Stage Manager — 20+ launch tours",
          desc: "Supervised over twenty event tours for national and international brands — from Nestlé to car launches: budgets, crews, routes and flawless execution.",
          period: "2006 — 2014",
          link: "https://www.highco.com/",
        },
      ],
      imgAlt: "Paris 2024 Olympic Games opening ceremony at the Trocadéro",
    },
    photo: {
      overline: "Chapter 03",
      title: "Photographer",
      body: "A side activity, a gaze in its own right. Portraits, light, texture: photography is how I slow down — and see.",
      filters: { all: "All", portrait: "Portraits", fineart: "Fine art" },
      close: "Close",
    },
    links: {
      overline: "Elsewhere",
      title: "Find me online",
      items: [
        { id: "linktree", label: "Linktree", desc: "All my links", url: "https://linktr.ee/thomaslubeau" },
        { id: "instagram", label: "Instagram", desc: "@thomaslubeau", url: "https://instagram.com/thomaslubeau" },
        { id: "linkedin", label: "LinkedIn", desc: "Thomas Lubeau", url: "https://www.linkedin.com/in/thomas-lubeau-2b1b64a5" },
        { id: "facebook", label: "Facebook", desc: "Thomas Lubeau", url: "https://www.facebook.com/thomas.lubeau" },
      ],
    },
    contact: {
      overline: "Contact",
      title: "Let's talk about your project",
      body: "Production company, event agency or business: write to me, I answer fast.",
      name: "Your name",
      namePh: "First Last",
      email: "Your email",
      emailPh: "you@company.com",
      type: "Project type",
      types: {
        production: "Fiction production",
        executive: "Executive production — shoot in France",
        event: "Event management",
        other: "Other",
      },
      message: "Your message",
      messagePh: "A few words about your project, your dates, your needs…",
      submit: "Send the message",
      sending: "Sending…",
      success: "Message sent — thank you, I'll get back to you very soon.",
      error: "Something went wrong. Please retry or email me directly.",
      directEmail: "Direct email",
      copy: "Copy",
      copied: "Address copied",
    },
    footer: "© 2026 Thomas Lubeau — lubeau.com",
  },
};

export const films = [
  { id: "quantic", title: "QUANTIC", type: "film", url: "https://ecran-total.fr/2026/07/22/david-sarrio-realise-quantic-son-premier-long-metrage/" },
  { id: "toto", title: "Thomas Lubeau", type: "film", url: "/videos/toto-teaser.mp4", video: "/videos/toto-teaser.mp4" },
  { id: "gueules-noires", title: "GUEULES NOIRES", type: "film", url: "https://www.imdb.com/title/tt20452218/" },
  { id: "pilote", title: "PILOTE", type: "film", url: "https://youtu.be/Ps6Jex_glFk", youtube: "Ps6Jex_glFk" },
  { id: "vertu", title: "VERTU", type: "series", url: "https://youtu.be/XAC-rQ1s5V8", youtube: "XAC-rQ1s5V8" },
  { id: "meandre", title: "MÉANDRE", type: "film", url: "https://youtu.be/crprt9Fe_hw", youtube: "crprt9Fe_hw" },
  { id: "hostile", title: "HOSTILE", type: "film", url: "https://youtu.be/Bf9mqWugWDQ", youtube: "Bf9mqWugWDQ" },
  { id: "night-fare", title: "NIGHT FARE", type: "film", url: "https://youtu.be/rlbvpwRWuoE", youtube: "rlbvpwRWuoE" },
  { id: "la-lisiere", title: "LA LISIÈRE", type: "film", url: "https://youtu.be/uijXEhXA-ZE", youtube: "uijXEhXA-ZE" },
  { id: "archeologist", title: "ARCHEOLOGIST OF THE WASTELAND", type: "short", url: "https://youtu.be/d85rFSeBCVM", youtube: "d85rFSeBCVM" },
];

export const otherCredits = [
  "L'ASSAUT", "GIBRALTAR", "BRAQUEURS", "BONNE POMME", "DE PLUS BELLE",
  "NOS FEMMES", "LA CONFESSION", "BAISERS CACHÉS", "NOX", "JUSTE UN REGARD",
  "UNE CHANCE DE TROP", "PLAYGROUND", "VIRGIN", "MAX", "TOUT, TOUT DE SUITE",
  "STARS 80, LA SUITE", "TRAFFICS", "LOL (USA)", "UNE RENCONTRE", "L'AFFAIRE SK1",
  "ON SOURIT POUR LA PHOTO",
];

export const photos = [
  { id: 0, cat: "portrait", url: "https://images.unsplash.com/photo-1506863530036-1efeddceb993?crop=entropy&cs=srgb&fm=jpg&q=85&w=900", altFr: "Portrait fine art en noir et blanc", altEn: "Fine art black and white portrait" },
  { id: 1, cat: "fineart", url: "https://images.unsplash.com/photo-1617746652908-91e66c07499a?crop=entropy&cs=srgb&fm=jpg&q=85&w=900", altFr: "Étude d'expression en noir et blanc à fort contraste", altEn: "High contrast black and white expression study" },
  { id: 2, cat: "fineart", url: "https://images.unsplash.com/photo-1587397845856-e6cf49176c70?crop=entropy&cs=srgb&fm=jpg&q=85&w=900", altFr: "Capture artistique monochrome, ombres et textures", altEn: "Monochrome artistic capture, shadows and texture" },
  { id: 3, cat: "portrait", url: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?crop=entropy&cs=srgb&fm=jpg&q=85&w=900", altFr: "Portrait lumineux", altEn: "Luminous portrait" },
  { id: 4, cat: "portrait", url: "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?crop=entropy&cs=srgb&fm=jpg&q=85&w=900", altFr: "Portrait masculin en noir et blanc", altEn: "Black and white male portrait" },
  { id: 5, cat: "fineart", url: "https://images.unsplash.com/photo-1493863641943-9b68992a8d07?crop=entropy&cs=srgb&fm=jpg&q=85&w=900", altFr: "Regard à travers l'objectif", altEn: "Gaze through the lens" },
];

export const images = {
  hero: "https://images.unsplash.com/photo-1612872750175-5b67ab0a6011?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  fiction: "/images/quantic.webp",
  event: "/images/jo-paris-2024.webp",
  event2: "https://images.unsplash.com/photo-1670028514318-0ac718c0590d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

export const EMAIL = "contact@lubeau.com";
